export enum Pages {
  Login = 'page::login',
  Home = 'page::home',
  UserManagement = 'page::user-management',
  Shipments = 'page::shipments',
  NotFound = 'page::not-found',
  Terms = 'page::terms',
};
